const { HTMLElementExt } = await import(
    window._resolveImport?.("html-element-ext") || "html-element-ext"
);

const _getGapInPx = (element) => {
    const computedStyles = window.getComputedStyle(element);
    const gap = parseFloat(computedStyles.gap);

    return gap === NaN ? 0 : gap;
};

class SliderVertical extends HTMLElementExt {
    constructor() {
        super();
        this.upButton = this.querySelector('button[name="up"]');
        this.downButton = this.querySelector('button[name="down"]');
        this.panel = this.querySelector(".slider-vertical--panel");

        this.bindedUpdateButtons = this.updateButtons.bind(this);
        this.handles = {
            "scroll::.slider-vertical--panel": this.bindedUpdateButtons,
            'click::button[name="up"]': (event) => {
                const gap = _getGapInPx(this.panel);

                event.preventDefault();
                this.panel.scrollTop -=
                    this.panel.children[0].offsetHeight + gap;
                setTimeout(this.bindedUpdateButtons, 200);
            },
            'click::button[name="down"]': (event) => {
                const gap = _getGapInPx(this.panel);

                event.preventDefault();
                this.panel.scrollTop +=
                    this.panel.children[0].offsetHeight + gap;
                setTimeout(this.bindedUpdateButtons, 200);
            },
            "window-resize-x::::document": this.updateButtons.bind(this),
        };
    }

    connectedCallback() {
        super.connectedCallback();
        this.updateButtons();
        this.dataset.status = "ready";
    }

    updateButtons() {
        const panel = this.panel;

        if (panel.scrollTop == 0) {
            this.upButton.style.setProperty("display", "none", "important");
        } else {
            this.upButton.style.setProperty("display", "");
        }

        if (panel.scrollHeight - panel.scrollTop == panel.clientHeight) {
            this.downButton.style.setProperty("display", "none", "important");
        } else {
            this.downButton.style.setProperty("display", "");
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        delete this.dataset.status;
    }
}

export { SliderVertical };
